import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DialogWithErrorLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithErrorLayout';

export default function AlertZeroResultsDialog (props) {
  const {
    className,
    headerClassName,
    headerTitleClassName,
    contentClassName,
    footerClassName,
  } = props;

  return (
    <DialogWithErrorLayout
      {...props}
      character="!"
      size="md"
      className={classnames(className, 'alert-zero-results-dialog')}
      headerClassName={classnames(headerClassName, 'alert-zero-results-dialog-header')}
      headerTitleClassName={classnames(headerTitleClassName, 'alert-zero-results-dialog-header-title')}
      contentClassName={classnames(contentClassName, 'alert-zero-results-dialog-content-wrapper')}
      footerClassName={classnames(footerClassName, 'alert-zero-results-dialog-footer')}
      header="No results"
    >
      Reaxys didn't find results for your query. Please consider reformulation and try again.
    </DialogWithErrorLayout>
  );
}

AlertZeroResultsDialog.propTypes = {
  selfClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  headerTitleClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
};
